/** Word-level IPA overrides for Portuguese. */
export const pt: Record<string, string> = {
  a: '/a/',
  agora: '/aˈɡoɾa/',
  ainda: '/aˈĩda/',
  alto: '/ˈawtu/',
  alvejei: '/awveˈʒej/',
  antes: '/ˈãtʃis/',
  // New sample overrides
  Antigamente: '/ãtʃiɡaˈmẽtʃi/',
  aparecesse: '/apaɾeˈsesi/',
  assembleia: '/asẽˈbleja/',
  automóveis: '/awtoˈmɔvejs/',
  autor: '/awˈtoɾ/',
  aventura: '/avẽˈtuɾa/',
  bater: '/baˈtex/',
  beija: '/ˈbejʒa/',
  bem: '/bẽj/',
  calmo: '/ˈkawmu/',
  cama: '/ˈkãma/',
  certa: '/ˈsɛɾta/',
  chamam: '/ˈʃãmãw/',
  como: '/ˈkomu/',
  contraparente: '/kõtɾapaˈɾẽtʃi/',
  costume: '/kosˈtũmi/',
  cotovelo: '/kotoˈvelu/',
  cruzarmos: '/kɾuzˈaɾmus/',
  d: '/de/', // abbreviation for Dom
  de: '/dʒi/',
  dei: '/dej/',
  dele: '/ˈdeli/',
  dentro: '/ˈdẽtɾu/',
  deu: '/dew/',
  dia: '/ˈdʒia/',
  direita: '/dʒiˈɾejta/',
  direito: '/dʒiˈɾejtu/',
  disco: '/ˈdʒisku/',
  disposto: '/dʒisˈpostu/',
  disse: '/ˈdʒisi/',
  dois: '/dojs/',
  é: '/ɛ/',
  emprenhou: '/ẽpɾeˈɲow/',
  encante: '/ẽˈkãtʃi/',
  entre: '/ˈẽtɾi/',
  escolherei: '/iskoʎeˈɾej/',
  esfíngico: '/esˈfĩʒiku/',
  eterna: '/eˈtɛɾna/',
  eu: '/ew/',
  Europa: '/ewˈɾɔpa/',
  face: '/ˈfasi/',
  faixas: '/ˈfajʃas/',
  falsa: '/ˈfawsa/',
  faz: '/fas/',
  fim: '/fĩ/',
  Fita: '/ˈfita/',
  fita: '/ˈfita/',
  fitando: '/fiˈtãdu/',
  flameja: '/flaˈmeʒa/',
  focinhando: '/fosiˈɲãdu/',
  foi: '/foj/',
  fossem: '/ˈfosẽj/',
  fosses: '/ˈfosis/',
  fragorosas: '/fɾaɡoˈɾozas/',
  francisco: '/fɾãˈsisku/',
  frente: '/ˈfɾẽtʃi/',
  fúlgidos: '/ˈfuwʒidus/',
  gente: '/ˈʒẽtʃi/',
  girassol: '/ʒiɾaˈsɔw/',
  gosto: '/ˈɡostu/',
  grandes: '/ˈɡɾãdʒis/',
  havia: '/aˈvia/',
  hei: '/ej/',
  hesitei: '/eziˈtej/',
  homens: '/ˈõmẽjs/',
  houve: '/ˈovi/',
  individuais: '/ĩdʒividuˈajs/',
  instante: '/ĩsˈtãtʃi/',
  instituir: '/ĩstʃituˈiɾ/',
  isso: '/ˈisu/',
  josé: '/ʒoˈzɛ/',
  liberdade: '/libeɾˈdadʒi/',
  lisboa: '/lizˈboa/',
  louca: '/ˈloka/',
  louvor: '/loˈvoɾ/',
  lua: '/ˈlua/',
  maior: '/maˈjoɾ/',
  mais: '/majs/',
  mal: '/maw/',
  margens: '/ˈmaɾʒẽjs/',
  maus: '/maws/',
  mestiçara: '/mestiˈsaɾa/',
  método: '/ˈmɛtudu/',
  mil: '/miw/',
  mim: '/mĩ/',
  morder: '/moɾˈdex/',
  morte: '/ˈmɔɾtʃi/',
  morto: '/ˈmoɾtu/',
  mostra: '/ˈmɔstɾa/',
  mulher: '/muˈʎɛx/',
  nacional: '/nasioˈnaw/',
  nascimento: '/nasiˈmẽtu/',
  nele: '/ˈneli/',
  nem: '/nẽj/',
  nesse: '/ˈnesi/',
  noite: '/ˈnojtʃi/',
  nonada: '/noˈnada/', // nothing (Guimarães Rosa)
  nosso: '/ˈnosu/',
  novo: '/ˈnovu/',
  num: '/nũ/',
  o: '/u/',
  ó: '/ɔ/',
  ondas: '/ˈõdas/',
  onde: '/ˈõdʒi/',
  ou: '/ow/',
  ousadia: '/ozaˈdʒia/',
  outono: '/owˈtonu/',
  outra: '/ˈowtɾa/',
  outro: '/ˈowtɾu/',
  para: '/ˈpaɾa/',
  parte: '/ˈpaɾtʃi/',
  passadeira: '/pasaˈdejɾa/',
  pode: '/ˈpɔdʒi/',
  portugal: '/poɾtuˈɡaw/',
  posso: '/ˈposu/',
  posta: '/ˈpɔsta/',
  povo: '/ˈpovu/',
  praia: '/ˈpɾaja/',
  prometia: '/pɾomeˈtʃia/',
  quanto: '/ˈkwãtu/',
  quarto: '/ˈkwaɾtu/',
  quer: '/kɛɾ/',
  querer: '/keˈɾex/',
  ramalhete: '/xamaˈʎetʃi/', // mansion name (Eça de Queirós)
  real: '/xeˈaw/',
  rebentavam: '/xebẽˈtavãw/',
  rei: '/xej/',
  reino: '/ˈxejnu/',
  remota: '/xeˈmɔta/',
  retumbante: '/xetũˈbãtʃi/',
  rir: '/xiɾ/',
  riso: '/ˈxizu/',
  rosto: '/ˈxostu/',
  rua: '/ˈxua/',
  s: '/sãw/', // abbreviation for São
  saber: '/saˈbex/',
  sal: '/saw/',
  sei: '/sej/',
  sem: '/sẽj/',
  sempre: '/ˈsẽpɾi/',
  senhor: '/seˈɲoɾ/',
  sequer: '/seˈkɛɾ/',
  ser: '/ˈsex/',
  sim: '/sĩ/',
  simples: '/ˈsĩplis/',
  Sob: '/sɔb/',
  sociais: '/sosiˈajs/',
  sol: '/sɔw/',

  sua: '/ˈsua/',
  sublimaram: '/subliˈmaɾãw/',
  tanto: '/ˈtãtu/',
  taprobana: '/tapɾoˈbãna/', // ancient Sri Lanka
  te: '/tʃi/',
  tempo: '/ˈtẽpu/',
  ter: '/tex/',
  tive: '/ˈtʃivi/',
  'toldam-lhe': '/ˈtowdãwʎi/',
  trapiche: '/tɾaˈpiʃi/',
  triste: '/ˈtɾistʃi/',
  um: '/ũ/',
  uma: '/ˈũma/',
  universo: '/uniˈvɛɾsu/',
  uso: '/ˈuzu/',
  vale: '/ˈvali/',
  verde: '/ˈveɾdʒi/',
  verdes: '/ˈveɾdʒis/',
  vez: '/ves/',
  viagem: '/viˈaʒẽj/',
  'vivê-lo': '/viˈvelu/',
  'vou-me': '/ˈvomi/',
  zelo: '/ˈzelu/',
  zomba: '/ˈzõba/',
};
